import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { PricingAndAccessService } from 'src/app/core/services/pricing-and-access/pricing-and-access.service';

@Component({
  selector: 'app-pricing-access-payment-receipt',
  templateUrl: './pricing-access-payment-receipt.component.html',
  styleUrls: ['./pricing-access-payment-receipt.component.css']
})
export class PricingAccessPaymentReceiptComponent implements OnInit {

  pricingAndAccessId: any;
  pricingAndAccess: any;
  transactionID: any;
  paymentDate: any;
  date: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private service: PricingAndAccessService) { }

  ngOnInit(): void {
    const redirectFlag = localStorage.getItem('paymentRedirect');
    if (redirectFlag === 'true') {
      setTimeout(() => {
        localStorage.removeItem('paymentRedirect');
      }, 5000);
    } else {
      this.router.navigate(['/pricing-and-plans']); 
    }
    this.pricingAndAccessId = this.route.snapshot.paramMap.get('pricingAccessId');
    this.service.getPricingAndAccessById(this.pricingAndAccessId).subscribe((res)=>{
      this.pricingAndAccess = res?.pricingAccess;
      this.transactionID = res?.chargeId;
      this.paymentDate = res?.paymentDate;
    })
  }

  userTimezoneNameSP(date: any) {
    var zone = moment.tz.guess();
    var newDate = new Date(date).toString()
    var timezoneName = moment(newDate).tz(zone).format('z')
    return timezoneName;
  }

  goBack(){
    this.router.navigate(['/pricing-and-plans']);
  }

}
